import { render, staticRenderFns } from "./reviewTwo.vue?vue&type=template&id=2be1ff5b&"
import script from "./reviewTwo.vue?vue&type=script&lang=js&"
export * from "./reviewTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports